import React, {useState, useEffect} from 'react';
import {TituloMenu,ColFlex, RowStyle, DivPedidoContenido} from '../clientes/style'
import {Row, Col, List, Card, Input, Button, Modal, Drawer, Tag, Icon} from 'antd'
import FormAgregarUsuario from './forms/FormAgregarUsuario';
import useWindowSize from '../../assets/js/use-windows-size';
import { useSelector, useDispatch } from 'react-redux';
import { Popconfirm, message } from 'antd';
import { actionGetUsuarios, actionRegistroUsuario, actionEditarUsuario, actionEliminarUsuario } from '../../store/acciones/accionesUsuario';
import { actionGetConfig } from '../../store/acciones/accionesConfig';

const { Search } = Input;

const Usuarios = () => {
    const size = useWindowSize();
    const [visible, showModal]=useState(false)
    const [visibleSider, showSider]=useState(false)
    const [dataUsuario, getDataUsuario]=useState()
    const [isMobile, windowResize]=useState(false)
    const dispatch = useDispatch();

    //Se obtienen las ordenes desde nuestra store usando useSelector
    let usuarios = useSelector(state => state.reducerUsuarios.usuarios);
 

    useEffect(() => {
        dispatch(actionGetUsuarios());
        dispatch(actionGetConfig());
          windowResize({isMobile:size.width<=360?true:false})
      }, [dispatch, size.width]);
    

    const openFormUsuario=(usuario)=>{
        getDataUsuario(usuario)
        showSider(true)
    }

    const editarUsuario=(values)=>{
         setTimeout(() => {
            let idUsuario=dataUsuario.id
            dispatch(actionEditarUsuario(idUsuario,values))
            showSider(false)
         }, 1000);
    }

    const agregarUsuario=(values)=>{
        setTimeout(() => {
            showModal(false)
            dispatch(actionRegistroUsuario(values))
         }, 1000);
       
    }
    const filterUsuarios=(e)=>{
         dispatch(actionGetUsuarios(e.target.value))
    }

    function confirm(item) {
        let idUsuario=item.id
         console.log(idUsuario)
         dispatch(actionEliminarUsuario(idUsuario))
    }

    function cancel(e) {
        message.error('Cancelado');
    }
    return (
        <>
        <TituloMenu>Usuarios</TituloMenu>
        <RowStyle type="flex" justify="space-around" align="middle">
            <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                <Search placeholder="nombre de usuario, nombre" onChange={(e)=>filterUsuarios(e)} enterButton />
            </ColFlex>
            <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                <div>
                    <Button icon="plus" type="primary" onClick={()=>showModal(true)}>
                        Agregar Usuario
                    </Button>
                    <Modal
                        title="Agregar Usuario"
                        visible={visible}
                        onOk={()=>showModal(false)}
                        onCancel={()=>showModal(false)}
                        footer={false}
                    >
                        <FormAgregarUsuario registro={agregarUsuario}/>
                    </Modal>
                </div>
            </ColFlex>
        </RowStyle>

        <Row type="flex" justify="space-around" align="middle">
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <List
                 pagination={{
                    pageSize: 10,
                  }}
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}
                    dataSource={usuarios}
                    renderItem={item => (
                        <List.Item>
                            <Card title={item.cliente} style={{height:"150px"}}>
                                <Row type="flex" justify="space-around" align="middle">
                                    <Col xl={19} lg={19} md={19} sm={24} xs={24}>
                                        <DivPedidoContenido>
                                            <p>Usuario: <span>{item.username}</span></p> 
                                            <p>Nombre: <span>{item.first_name} {item.last_name}</span></p>
                                            <p>Tipo:
                                                
                                                    {item.user_permissions && item.user_permissions.length>0?
                                                        item.user_permissions.map((c, key) => (
                                                            <Tag key={key} color="geekblue"><Icon type="user" style={{ fontSize: '20px' }} /> {c.codename}</Tag>
                                                          ))
                                                    :null   
                                                    }
                                                   
                                               
                                            </p>
                                        </DivPedidoContenido>
                                    </Col>
                                  
                                    <Col l={5} lg={5} md={5} sm={24} xs={24}>
                                        <Button type="primary" icon="edit" onClick={() => openFormUsuario(item)} style={{marginBottom:"1em"}}>Editar</Button>
                                        <Popconfirm
                                            title="Desea eliminar el usuario?"
                                            onConfirm={() => confirm(item)}
                                            onCancel={cancel}
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <Button icon="delete" type="danger" >Eliminar</Button>
                                        </Popconfirm>

                                    </Col>
                                </Row>
                            </Card>
                        </List.Item>
                    )}
                />
                <Drawer
                        title="Editar Usuario"
                        placement="right"
                        closable={false}
                        onClose={() => showSider(false)}
                        visible={visibleSider}
                        width={isMobile.isMobile ? "90%" : "40%"}
                        destroyOnClose
                    >
                            {/* <FormEditarCliente registro={editarCliente} cliente={dataCliente}/> */}
                            <FormAgregarUsuario  registro={editarUsuario} usuario={dataUsuario}/>
                    </Drawer>
            </Col>
        </Row>
    </>
    );
};

export default Usuarios;